var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.availableRecipients.length)?_c('div',{staticClass:"order-item-details-recipients"},_vm._l((_vm.availableRecipients),function(recipient,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(recipient.first_name)+" "+_vm._s(recipient.last_name)+" "),(recipient.region)?[_vm._v(" ("+_vm._s(recipient.region)+") ")]:_vm._e()],2)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }